import { useCheckAndSetCurrentCustomer } from '../../auth.service'

const CustomerProvider: React.FC = () => {
  useCheckAndSetCurrentCustomer()

  return null
}

export default CustomerProvider
